import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TmCartLine } from '@/tscapi/model/cart';
import { TmProduct } from '@/tscapi/model/product';

import { en, fr } from '../i18n';

interface ICartLine {
    CartLine: TmCartLine;
    CartProducts: TmProduct[];
    Remove: () => void;
    Update: () => void;
    QuantityAddedOveride?: number;
}

export const ItemCard = ({ CartLine, CartProducts, Remove, QuantityAddedOveride }: ICartLine) => {
    const { i18n, t } = useTranslation('addtobag');
    i18n.addResourceBundle('en', 'addtobag', en, true, true);
    i18n.addResourceBundle('fr', 'addtobag', fr, true, true);

    if (!CartProducts) {
        return null;
    }

    //find full product data for this item
    const product: TmProduct = CartProducts.find((x) => x.ItemNo == CartLine.CartLineItem.ItemNo);
    //find edpdata specific to this lineitem
    const edpData = product?.Edps.find((y) => y.EdpNo == CartLine.CartLineItem.EdpNo);

    if (!product) {
        return null;
    }

    return (
        <>
            <div className="grid grid-cols-[96px_auto_1px] gap-x-4 pb-3.5 md:grid-cols-[96px_auto_85px]">
                <div className="z col-span-1 w-24">
                    <a href={product?.ProductLink.LinkWithoutDomain} target="_blank" rel="noreferrer">
                        <img
                            alt=""
                            id={`badge${CartLine.CartLineItem.ItemNo}`}
                            className="img-responsive center-block"
                            width="96"
                            height="96"
                            src={`https://item.tscimg.ca/TSC/${CartLine.CartLineItem.ImageUrl}?impolicy=M`}
                        />
                    </a>
                </div>
                <div className="col-start-2 col-end-3 text-[13px] font-light md:col-end-2">
                    {product.PriceIsLabel ? (
                        <div className="mb-2 text-[10px] font-semibold uppercase  leading-normal text-black">
                            {product.PriceIsLabel}
                        </div>
                    ) : null}

                    <a href={product.ProductLink.LinkWithoutDomain} target="_blank" rel="noreferrer">
                        <span className="mb-2 line-clamp-2 text-[13px] font-semibold leading-tight">
                            {product.Name}
                        </span>
                    </a>

                    <div>
                        {CartLine.CartLineItem.ItemNo.slice(0, 3) + '-' + CartLine.CartLineItem.ItemNo.slice(3, 6)}
                    </div>

                    {(CartLine.CartLineItem.Size || CartLine.CartLineItem.Style) && (
                        <div>
                            {CartLine.CartLineItem.Size && (
                                <span>
                                    {t('Size')}: {CartLine.CartLineItem.Size}
                                </span>
                            )}
                            {CartLine.CartLineItem.Size && CartLine.CartLineItem.Style && (
                                <span className="px-1.5">|</span>
                            )}
                            {CartLine.CartLineItem.Style && (
                                <span>
                                    {t('Style')}: {CartLine.CartLineItem.Style}
                                </span>
                            )}
                        </div>
                    )}

                    <div>Quantity: {QuantityAddedOveride ? QuantityAddedOveride : CartLine.InCart.Quantity}</div>
                </div>
                <div className="col-start-2 col-end-4 row-start-2 row-end-3 mb-2 text-right text-sm md:col-start-3 md:col-end-4 md:row-start-1 md:row-end-2">
                    <div className="flex-col md:flex md:flex-wrap">
                        <span className="font-semibold">{CartLine.InCart.UnitPrice}</span>
                        {CartLine.InCart.UnitPrice != edpData.WasPrice && (
                            <span className="ml-2.5 line-through md:ml-0">{edpData.WasPrice}</span>
                        )}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        {!CartLine.CartLineItem.IsDonation &&
                            (CartLine.InCart.ShippingHandling == 'FREE' ||
                                CartLine.InCart.ShippingHandling == 'GRATUIT') && (
                                <span className="mt-2.5 inline-block border border-solid border-black px-1.5 text-xxsm font-semibold">
                                    {t('Free shipping')}
                                </span>
                            )}
                    </div>
                </div>
                {CartLine.InCart.IsEditable && (
                    <div className="col-start-2 col-end-4 row-start-3 row-end-4 text-right text-sm">
                        <button type="button" className="text-[13px] underline" onClick={Remove}>
                            {t('Remove')}
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};
